<template>
  <div>
    <LogTimeLoggerPopover
      :task="task"
      :key="loggedTime"
      :open.sync="isPopoverOpen"
      :disabled="disabled"
      :source="'task_details_header'"
      @update="(time) => $emit('update', time)"
    >
      <LogTimeButton
        :button-classes="[
          'direction-left',
          { 'is-active': isPopoverOpen || loggedTime !== '0h' },
        ]"
        :tooltip="$t('Log time')"
        icon="clock"
        @click.native="trackLogTime"
      />
    </LogTimeLoggerPopover>
  </div>
</template>
<script>
import LogTimeButton from '@widgets/TaskDetailWidgets/LogTimeButton';
import LogTimeLoggerPopover from '@widgets/LogTimeLoggerPopover/LogTimeLoggerPopover';

import useExperimentA15 from '@/platform/composables/useExperimentA15';
import useExperiment from '@/platform/composables/useExperiment';
import { useBaseMetrics } from '@/platform/composables/useBaseMetrics';

export default {
  name: 'LogTimeLogger',
  components: {
    LogTimeButton,
    LogTimeLoggerPopover,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loggedTime: {
      type: String,
      required: true,
    },
    showTimeList: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { EXP_A15_COMMON_METRICS } = useExperimentA15();
    const { trackPendoEvent } = useExperiment();
    const { getCommonFields } = useBaseMetrics();

    const trackLogTime = () => {
      getCommonFields(EXP_A15_COMMON_METRICS).then((commonFields) => {
        trackPendoEvent('TASK_DETAILS_EVENT', {
          ...commonFields,
          event_action: 'log_time_clicked',
          event_source: 'task_details_header',
        });
      });
    };

    return {
      trackLogTime,
    };
  },
  computed: {
    isPopoverOpen: {
      get() {
        return this.open;
      },
      set(newVal) {
        this.$emit('update:open', newVal);
      },
    },
  },
};
</script>
<style>
.log-time__wrapper div {
  height: 100%;
}
</style>
